<template>
  <div style="background-color: white; width: 100%;">
    <div id="container" v-if="dataSet != null && applicationData != null">
      <dialog id="modal-settings">
        <svg @click="closeModal('modal-settings')" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <h3>Settings</h3>
        <hr />
        <h5>Application</h5>
        <div class="border-color">
          <div>
            <label class="custom-file-label-global">Upload
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31L216 408z"/></svg>
              <input name="image" id="imported-logo" @change="(e) => {handleFileChangeObject(e, inputObjectApp, 'image'); applicationData.image = ''}" type="file" accept=".jpg, .jpeg, .png, .gif, .svg">
            </label>
          </div>
          <div style="display: flex; justify-content: center;">
            <img v-if="this.applicationData.image != ''" :src="`${reverseProxy}/api/${applicationData.image}`" alt="Picture N/A" loading="lazy" width="auto" height="200px"/>
            <img v-else :src="getURLImage(this.inputObjectApp.image)"  width="auto" height="200px" />
          </div>
        </div>
        <div v-if="applicationData" class="modal-settings-content-grid">
          <div>Application ID</div>
          <div>
            {{ this.applicationData.application_id }}
          </div>
          <div>Application Custom ID</div>
          <div>
            <input type="text" v-model="applicationData.application_custom_id" />
          </div>
          <div>Owner UUID</div>
          <div>
            {{ this.applicationData.owner_uuid }}
          </div>
          <div>Classification</div>
          <div>
            <select v-model="applicationData.classification">
              <option value="Assessment/Test">Assessment/Test</option>
              <option value="Screening/Mini-Test">Screening/Mini-Test</option>
              <option value="Intervention/Training/Lesson">Intervention/Trainging/Lesson</option>
            </select>
          </div>
          <div>Title</div>
          <div>
            <input type="text" v-model="applicationData.title" />
          </div>
          <div>Subtitle</div>
          <div>
            <input type="text" v-model="applicationData.subtitle" />
          </div>
          <div>Info</div>
          <div>
            <textarea type="text" v-model="applicationData.info"></textarea>
          </div>
          <div>Area</div>
          <div>
            {{ applicationData.area }}
          </div>
          <div>Created</div>
          <div>
            {{ formatTimestamp(this.applicationData.created) }}
          </div>
        </div>
        <hr />
        <h5>Pricing</h5>
        <div>
          <input type="radio" v-model="pricingOption" name="pricing-option" value="free" />
          Free
        </div>
        <div>
          <input type="radio" v-model="pricingOption" name="pricing-option" value="pricing" />
          Pricing
        </div>
        <div v-if="pricingOption == 'pricing'" id="pricing-sublist" class="modal-settings-content-grid">
          <div>
            Single Unit Pricing
          </div>
          <div>
            <select v-model="applicationData.currency_code" style="width: fit-content; display: inline-block; margin-right: .5rem;">
              <option value="USD">$ (USD)</option>
              <option value="EUR">€ (EUR)</option>
              <option value="GBP">£ (GBP)</option>
              <option value="JPY">¥ (JPY)</option>
              <option value="CNY">¥ (CNY)</option>
              <option value="RUB">₽ (RUB)</option>
            </select>
            <input type="number" v-model="applicationData.single_unit_pricing" style="width: fit-content; display: inline-block;">
          </div>
          <div>
            Monthly Subscription
          </div>
          <div>
            <select v-model="applicationData.currency_code" style="width: fit-content; margin-right: .5rem;">
              <option value="USD">$ (USD)</option>
              <option value="EUR">€ (EUR)</option>
              <option value="GBP">£ (GBP)</option>
              <option value="JPY">¥ (JPY)</option>
              <option value="CNY">¥ (CNY)</option>
              <option value="RUB">₽ (RUB)</option>
            </select>
            <input type="number" v-model="applicationData.monthly_subscription_pricing" style="width: fit-content; display: inline-block;">
            &nbsp; per Month
          </div>
        </div>
        <hr />
        <h5>Deployment</h5>
        <div class="modal-settings-content-grid">
          <div>Set if for Sale</div>
          <div>
            <div v-if="!loadingSaleChanges">
              <button v-if="this.applicationData.on_sale" @click="changeSale(false)">
                Remove From Sale
              </button>
              <button v-else @click="changeSale(true)">
                Set On Sale
              </button>
            </div>
            <div v-else>
              <button v-if="this.applicationData.on_sale">
                <b-spinner small></b-spinner>
                Remove From Sale
              </button>
              <button v-else>
                <b-spinner small></b-spinner>
                Set On Sale
              </button>
            </div>
          </div>
          <div>Publish/Unpublish Apps</div>
          <div>
            <div v-if="!loadingPublishApps">
              <button v-if="this.applicationData.published" @click="publishApp(false)">
                Unpublish
              </button>
              <button v-else @click="publishApp(true)">
                Publish
              </button>
            </div>
            <div v-else>
              <button v-if="this.applicationData.published">
                <b-spinner small></b-spinner>
                Unpublish
              </button>
              <button v-else>
                <b-spinner small></b-spinner>
                Publish
              </button>
            </div>
          </div>
        </div>
      </dialog>
      <div v-if="currStep == 'question'">
        <dialog v-if="questionIndex >= 0" id="modal-config-question">
          <svg @click="closeModal('modal-config-question')" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
          <dialog id="modal-procedure">
            <svg @click="closeModal('modal-procedure')" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
            <h3>Procedure</h3>
            <p>{{ dataSet[questionIndex].procedure }}</p>
          </dialog>
          <dialog id="modal-childPrompts">
            <svg @click="closeModal('modal-childPrompts')" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
            <h3>TTS Child Prompts</h3>
            <div v-for="(item,index) in dataSet[questionIndex].tts_child_prompts" :key="index">
              <p>{{ item }}</p>
              <button class="subButton" @click="convertToSpeech(item)">TTS</button>
            </div>
          </dialog>
          <dialog id="modal-specialist_prompt">
            <svg @click="closeModal('modal-specialist_prompt')" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
            <h3>Specialist Prompt</h3>
            <p>{{ dataSet[questionIndex].specialist_prompt }}</p>
          </dialog>
          <dialog id="modal-notes">
            <svg @click="closeModal('modal-notes')" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
            <h3>Notes</h3>
            <textarea style="border: solid black 1px"></textarea>
          </dialog>
          <DragResizeElement
            v-if="configDragResizeWindow"
            :detailsObject="null"
            :bound="false"
            @deselectObjectMoveResize="deselectObjectMoveResize"
            @selectObjectMoveResize="selectObjectMoveResize"
            class="config-drag-resize-window"
            id="question-configuration-window-container"
          >
            <div class="drag-resize-element-container">
              <h4>Question Configuration</h4>
              <div class="masonry">
                <div>
                  <h5>General</h5>
                  <div>Question ID:</div>
                  <div>
                    <div style="border-radius: 50rem; padding: 5px 10px; border-radius: 5px; border: solid 1px #929292;">. . .{{ dataSet[questionIndex].question_id.slice(-4) }}</div>
                  </div>
                  <div>Question:</div>
                  <div>
                    <textarea v-model="dataSet[questionIndex].question" :disabled="!editToggle"></textarea>
                  </div>
                  <div>Question Description:</div>
                  <div>
                    <textarea v-model="dataSet[questionIndex].question_description" :disabled="!editToggle"></textarea>
                  </div>
                  <div>Procedure:</div>
                  <div>
                    <textarea v-model="dataSet[questionIndex].procedure" :disabled="!editToggle"></textarea>
                  </div>
                  <div>Specialist Prompt:</div>
                  <div>
                    <textarea v-model="dataSet[questionIndex].specialist_prompt" :disabled="!editToggle"></textarea>
                  </div>
                  <div>Highest Possible Score</div>
                  <div>
                    <input type="number" v-model="dataSet[questionIndex].highest_score_possible"  min="0" max="4" :disabled="!editToggle">
                  </div>
                  <div>Time Out</div>
                  <div>
                    <input type="number" v-model="dataSet[questionIndex].time_out" :disabled="!editToggle"> sec.
                  </div>
                  <div>
                    Typical Duration:
                  </div>
                  <div>
                    <input type="number" v-model="dataSet[questionIndex].typical_duration" :disabled="!editToggle"> sec.
                  </div>
                </div>
                <div>
                  <h5>Categorizations</h5>
                  <div>Area:</div>
                  <div>
                    <select v-model="dataSet[questionIndex].area">
                      <option v-for="(area, index) in categorizationsData.areas" :key="`areaQuestion-${index}`">{{ area }}</option>
                    </select>
                  </div>
                  <div>Area Description:</div>
                  <div>
                    <textarea v-model="dataSet[questionIndex].area_description" :disabled="!editToggle"></textarea>
                  </div>
                  <div>Type:</div>
                  <div>
                    <select v-model="dataSet[questionIndex].type">
                      <option v-for="(type, index) in categorizationsData.types" :key="`typeQuestion-${index}`">{{ type }}</option>
                    </select>
                  </div>
                  <div>Type Description:</div>
                  <div>
                    <textarea v-model="dataSet[questionIndex].type_description" :disabled="!editToggle"></textarea>
                  </div>
                  <div>Category:</div>
                  <div>
                    <select v-model="dataSet[questionIndex].category">
                      <option v-for="(categ, index) in categorizationsData.categories" :key="`categQuestion-${index}`">{{ categ }}</option>
                    </select>
                  </div>
                  <div>Category Description:</div>
                  <div>
                    <textarea v-model="dataSet[questionIndex].category_description" :disabled="!editToggle"></textarea>
                  </div>
                  <div>SubCategory:</div>
                  <div>
                    <select v-model="dataSet[questionIndex].sub_category">
                      <option v-for="(subCateg, index) in categorizationsData.sub_categories" :key="`subCategQuestion-${index}`">{{ subCateg }}</option>
                    </select>
                  </div>
                  <div>SubCategory Description:</div>
                  <div>
                    <textarea v-model="dataSet[questionIndex].sub_category_description" :disabled="!editToggle"></textarea>
                  </div>
                </div>
                <div class="grid-span-column-2">
                  <h5>Display</h5>
                  <div>Background Color:</div>
                  <div>
                    <label :for="`backColor-picker-${dataSet[questionIndex].question_id}`" class="custom-color-label-global">
                      {{ dataSet[questionIndex].background_color }}
                      <img src="../images/icons_svg/general/color-picker.svg" />
                      <input :id="`backColor-picker-${dataSet[questionIndex].question_id}`" v-model="dataSet[questionIndex].background_color" type="color" :disabled="!editToggle">
                    </label>
                  </div>
                  <hr />
                  <h6>Templates</h6>
                  <span class="template-container">
                    <button @click="addTemplateElements(dataSet[questionIndex], '1')">Add</button>
                    <svg viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="500" height="500" fill="#1E1E1E"/>
                      <path d="M500 0H0V500H500V0Z" fill="white"/>
                      <path d="M18 472C18 478.627 23.3726 484 30 484H469C475.627 484 481 478.627 481 472V29C481 22.3726 475.627 17 469 17H30C23.3726 17 18 22.3726 18 29V472Z" fill="#EECC9A"/>
                    </svg>
                  </span>
                  <span class="template-container">
                    <button @click="addTemplateElements(dataSet[questionIndex], '2')">Add</button>
                    <svg viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="500" height="500" fill="#1E1E1E"/>
                      <path d="M500 0H0V500H500V0Z" fill="white"/>
                      <path d="M10 344C10 350.627 15.3726 356 22 356H477C483.627 356 489 350.627 489 344V33C489 26.3726 483.627 21 477 21H22C15.3726 21 10 26.3726 10 33V344Z" fill="#EECC9A"/>
                      <path d="M10 472C10 478.627 15.3726 484 22 484H216C222.627 484 228 478.627 228 472V377C228 370.373 222.627 365 216 365H22C15.3726 365 10 370.373 10 377V472Z" fill="#FF9B00"/>
                      <path d="M271 472C271 478.627 276.373 484 283 484H477C483.627 484 489 478.627 489 472V377C489 370.373 483.627 365 477 365H283C276.373 365 271 370.373 271 377V472Z" fill="#FF9B00"/>
                    </svg>
                  </span>
                  <span class="template-container">
                    <button @click="addTemplateElements(dataSet[questionIndex], '3')">Add</button>
                    <svg viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="500" height="500" fill="#1E1E1E"/>
                      <path d="M500 0H0V500H500V0Z" fill="white"/>
                      <path d="M269 55C269 61.6274 274.373 67 281 67H469C475.627 67 481 61.6274 481 55V27C481 20.3726 475.627 15 469 15H281C274.373 15 269 20.3726 269 27V55Z" fill="#FF9B00"/>
                      <path d="M269 215C269 221.627 274.373 227 281 227H469C475.627 227 481 221.627 481 215V187C481 180.373 475.627 175 469 175H281C274.373 175 269 180.373 269 187V215Z" fill="#FF9B00"/>
                      <path d="M269 135C269 141.627 274.373 147 281 147H469C475.627 147 481 141.627 481 135V107C481 100.373 475.627 95 469 95H281C274.373 95 269 100.373 269 107V135Z" fill="#FF9B00"/>
                      <path d="M269 295C269 301.627 274.373 307 281 307H469C475.627 307 481 301.627 481 295V267C481 260.373 475.627 255 469 255H281C274.373 255 269 260.373 269 267V295Z" fill="#FF9B00"/>
                      <path d="M269 455C269 461.627 274.373 467 281 467H469C475.627 467 481 461.627 481 455V427C481 420.373 475.627 415 469 415H281C274.373 415 269 420.373 269 427V455Z" fill="#FF9B00"/>
                      <path d="M269 375C269 381.627 274.373 387 281 387H469C475.627 387 481 381.627 481 375V347C481 340.373 475.627 335 469 335H281C274.373 335 269 340.373 269 347V375Z" fill="#FF9B00"/>
                      <path d="M19 458C19 464.627 24.3726 470 31 470H238C244.627 470 250 464.627 250 458V27C250 20.3726 244.627 15 238 15H31C24.3726 15 19 20.3726 19 27V458Z" fill="#EECC9A"/>
                    </svg>
                  </span>
                  <span class="template-container">
                    <button @click="addTemplateElements(dataSet[questionIndex], '4')">Add</button>
                    <svg viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="500" height="500" fill="#1E1E1E"/>
                      <path d="M500 0H0V500H500V0Z" fill="white"/>
                      <path d="M29 352C29 358.627 34.3726 364 41 364H442C448.627 364 454 358.627 454 352V26C454 19.3726 448.627 14 442 14H41C34.3726 14 29 19.3726 29 26V352Z" fill="#EECC9A"/>
                      <path d="M29 413C29 419.627 34.3726 425 41 425H217C223.627 425 229 419.627 229 413V394C229 387.373 223.627 382 217 382H41C34.3726 382 29 387.373 29 394V413Z" fill="#FF9B00"/>
                      <path d="M254 413C254 419.627 259.373 425 266 425H442C448.627 425 454 419.627 454 413V394C454 387.373 448.627 382 442 382H266C259.373 382 254 387.373 254 394V413Z" fill="#FF9B00"/>
                      <path d="M29 474C29 480.627 34.3726 486 41 486H217C223.627 486 229 480.627 229 474V455C229 448.373 223.627 443 217 443H41C34.3726 443 29 448.373 29 455V474Z" fill="#FF9B00"/>
                      <path d="M254 474C254 480.627 259.373 486 266 486H442C448.627 486 454 480.627 454 474V455C454 448.373 448.627 443 442 443H266C259.373 443 254 448.373 254 455V474Z" fill="#FF9B00"/>
                    </svg>
                  </span>
                  <span class="template-container">
                    <button @click="addTemplateElements(dataSet[questionIndex], '5')">Add</button>
                    <svg viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="500" height="500" fill="#1E1E1E"/>
                      <path d="M500 0H0V500H500V0Z" fill="white"/>
                      <path d="M126 449C126 455.627 131.373 461 138 461H362C368.627 461 374 455.627 374 449V52C374 45.3726 368.627 40 362 40H138C131.373 40 126 45.3726 126 52V449Z" fill="#EECC9A"/>
                      <path d="M12 218C12 224.627 17.3726 230 24 230H106C112.627 230 118 224.627 118 218V52C118 45.3726 112.627 40 106 40H24C17.3726 40 12 45.3726 12 52V218Z" fill="#FF9B00"/>
                      <path d="M12 449C12 455.627 17.3726 461 24 461H106C112.627 461 118 455.627 118 449V283C118 276.373 112.627 271 106 271H24C17.3726 271 12 276.373 12 283V449Z" fill="#FF9B00"/>
                      <path d="M382 218C382 224.627 387.373 230 394 230H476C482.627 230 488 224.627 488 218V52C488 45.3726 482.627 40 476 40H394C387.373 40 382 45.3726 382 52V218Z" fill="#FF9B00"/>
                      <path d="M382 449C382 455.627 387.373 461 394 461H476C482.627 461 488 455.627 488 449V283C488 276.373 482.627 271 476 271H394C387.373 271 382 276.373 382 283V449Z" fill="#FF9B00"/>
                    </svg>
                  </span>
                  <hr />
                  <h6>Insert Elements</h6>
                  <div>Number of Child Images:</div>
                  <div>
                    <input type="number" v-model="dataSet[questionIndex].numberChildImages" @change="numberFormatImageChange(dataSet[questionIndex], 'child_images', dataSet[questionIndex].numberChildImages)" min="0" max="12" :disabled="!editToggle">
                  </div>
                  <div>
                    Number of Child Buttons:
                  </div>
                  <div>
                    <input type="number" v-model="dataSet[questionIndex].numberChildButtons" @change="numberFormatButtonChange(dataSet[questionIndex], 'child_buttons', dataSet[questionIndex].numberChildButtons)" min="0" max="12" :disabled="!editToggle">
                  </div>
                </div>
              </div>
            </div>
          </DragResizeElement>
          <div id="config-control-box-specialist">
            <div style="display: flex; justify-content: center; align-items: center;">
              <span class="prev-ques-nav-buttons">
                <img src="../images/icons_svg/general/left-circle.svg" />
              </span>
              <span class="prev-ques-nav-buttons">
                <img src="../images/icons_svg/general/right-circle.svg" />
              </span>
              <span class="prev-ques-nav-buttons">
                <img src="../images/icons_svg/general/rotate-circle.svg" />
              </span>
            </div>
            <div style="display: flex; justify-content: center; align-items: center;">
              {{ dataSet[questionIndex].question }}
            </div>
            <div style="display: flex; justify-content: center; align-items: center;">
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/list-search.svg" class='preview-icons'/>
                <div>Previous Results</div>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/graph.svg" class='preview-icons'/>
                <div>Reports</div>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/student-graduation.svg" class='preview-icons'/>
                <div>Child View</div>
              </span>
            </div>
            <div class="d-flex flex-column justify-content-between m-3 flex-shrink-0">
              <div style="font-size: .9rem;">
                <div class="mt-3">{{ `Q. ${questionIndex+1}` }}</div>
                <div><span style="margin-top: 1rem; text-decoration: underline;">Area:</span> {{ dataSet[questionIndex].area }}</div>
                <div><span style="margin-top: 1rem; text-decoration: underline;">Type:</span> {{ dataSet[questionIndex].type }}</div>
                <div><span style="margin-top: 1rem; text-decoration: underline;">Category:</span> {{ dataSet[questionIndex].category }}</div>
                <div><span style="margin-top: 1rem; text-decoration: underline;">Subcategory:</span> {{ dataSet[questionIndex].sub_category }}</div>
                <div style="margin-top: 1rem">
                  <span>
                    <span style="text-decoration: underline;">Question ID:</span>
                    ...{{ dataSet[questionIndex].question_id.slice(-4) }}
                  </span>
                  <div>
                    <span>
                      <span style="text-decoration: underline;">Custom QID:</span>
                      ...{{ dataSet[questionIndex].custom_id.slice(-4) }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column">
                <div v-for="(item, index) in dataSet[questionIndex].specialist_buttons" :key="index">
                  <button v-if="index % 2 === 0" class="exampleButton">{{ item.text }}</button>
                </div>
              </div>
            </div>
            <div class="border-color-primary" id="preview-screen-specialist" :style="{backgroundColor:dataSet[questionIndex].background_color, position: 'relative', height: '500px'}">
              <DragResizeElement
                v-if="selectedObjectMoveResize.detailsObject"
                :detailsObject="null"
                :bound="false"
                class="config-drag-resize-window"
              >
                <div class="drag-resize-element-container">
                  <h4>Configure Window</h4>
                  <table>
                    <tr v-if="selectedObjectMoveResize.detailsObject.hasOwnProperty('file')">
                      <td>File: </td>
                      <td>
                        <label :for="`config-file-1`" class="custom-file-label-global">
                          <span v-if="selectedObjectMoveResize.detailsObject.file == null"> Image
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31L216 408z"/></svg>
                          </span>
                          <span v-else>
                            {{ selectedObjectMoveResize.detailsObject.fileRef ? selectedObjectMoveResize.detailsObject.file.Filename : selectedObjectMoveResize.detailsObject.file.name }}
                          </span>
                          <input type="file" :id="`config-file-1`" @change="e => handleFileChangeObject(e, selectedObjectMoveResize.detailsObject, 'file')" accept=".jpg, .jpeg, .png, .gif" :disabled="!editToggle">
                        </label>
                      </td>
                    </tr>
                    <tr v-if="selectedObjectMoveResize.detailsObject.hasOwnProperty('text')">
                      <td>Text: </td>
                      <td>
                        <input type="text" v-model="selectedObjectMoveResize.detailsObject.text" :disabled="!editToggle" placeholder="(Insert Text)">
                      </td>
                    </tr>
                    <tr v-if="selectedObjectMoveResize.detailsObject.hasOwnProperty('x')">
                      <td>x: </td>
                      <td>
                        <input type="number" v-model="selectedObjectMoveResize.detailsObject.x" :disabled="!editToggle" placeholder="(Insert x)">
                      </td>
                    </tr>
                    <tr v-if="selectedObjectMoveResize.detailsObject.hasOwnProperty('y')">
                      <td>y: </td>
                      <td>
                        <input type="number" v-model="selectedObjectMoveResize.detailsObject.y" :disabled="!editToggle" placeholder="(Insert y)">
                      </td>
                    </tr>
                    <tr v-if="selectedObjectMoveResize.detailsObject.hasOwnProperty('width')">
                      <td>Width: </td>
                      <td>
                        <input type="number" v-model="selectedObjectMoveResize.detailsObject.width" :disabled="!editToggle" placeholder="(Insert Width)">
                      </td>
                    </tr>
                    <tr v-if="selectedObjectMoveResize.detailsObject.hasOwnProperty('height')">
                      <td>Height: </td>
                      <td>
                        <input type="number" v-model="selectedObjectMoveResize.detailsObject.height" :disabled="!editToggle" placeholder="(Insert Height)">
                      </td>
                    </tr>
                    <tr v-if="selectedObjectMoveResize.detailsObject.hasOwnProperty('background_color')">
                      <td>Background Color: </td>
                      <td>
                        <label :for="`config-backColor-1`" class="custom-color-label-global">
                          {{ selectedObjectMoveResize.detailsObject.background_color }}
                          <img src="../images/icons_svg/general/color-picker.svg" />
                          <input :id="`config-backColor-1`" type="color" v-model="selectedObjectMoveResize.detailsObject.background_color" :disabled="!editToggle" placeholder="(Insert Hex Value)">
                        </label>
                      </td>
                    </tr>
                    <tr v-if="selectedObjectMoveResize.detailsObject.hasOwnProperty('fontSize')">
                      <td>Font Size: </td>
                      <td>
                        <input type="number" v-model="selectedObjectMoveResize.detailsObject.fontSize" :disabled="!editToggle">
                      </td>
                    </tr>
                    <tr v-if="selectedObjectMoveResize.detailsObject.hasOwnProperty('zIndex')">
                      <td>Z-Index: </td>
                      <td>
                        <input type="number" v-model="selectedObjectMoveResize.detailsObject.zIndex" :disabled="!editToggle">
                      </td>
                    </tr>
                  </table>
                  <button style="background-color: #EE4B2B;" @click="() => findandRemoveImageButton(selectedObjectMoveResize.detailsObject)">Delete Element</button>
                </div>
              </DragResizeElement>
              <DragResizeElement 
                v-for="(image, index2) in dataSet[questionIndex].child_images" :key="`image-${index2}`"
                :style="{
                  top: `${image.y}px`,
                  left: `${image.x}px`,
                  width: `${image.width}px`,
                  height: `${image.height}px`,
                  backgroundColor: image.background_color,
                  zIndex: image.zIndex,
                }"
                @deselectObjectMoveResize="deselectObjectMoveResize"
                @selectObjectMoveResize="selectObjectMoveResize"
                class="resizable-image-container"
                :detailsObject="image"
                :bound="true"
              >
                <img v-if="image.fileRef" :src="`${reverseProxy}/api/${image.fileRef}`" width="100%" height="100%">
                <img v-else :src="getImageFileSrc(image)" width="100%" height="100%">
              </DragResizeElement>
              <DragResizeElement
                v-for="(button, index2) in dataSet[questionIndex].child_buttons" :key="`button-${index2}`"
                :style="{
                  top: `${button.y}px`,
                  left: ` ${button.x}px`,
                  width: `${button.width}px`,
                  height: `${button.height}px`,
                  backgroundColor: button.background_color,
                  zIndex: button.zIndex,
                  fontSize: `${button.fontSize}px`,
                }"
                @deselectObjectMoveResize="deselectObjectMoveResize"
                @selectObjectMoveResize="selectObjectMoveResize"
                class="resizable-button-container"
                :detailsObject="button"
                :bound="true"
              >
                <img v-if="button.fileRef" :src="`${reverseProxy}/api/${button.fileRef}`" width="100%" height="100%">
                <img v-else :src="getImageFileSrc(button)" width="100%" height="100%">
                <div class="placeholder-rect">{{ button.text }}</div>
              </DragResizeElement>
            </div>
            <div class="d-flex flex-column justify-content-between m-3 flex-shrink-0">
              <div style="font-size: .9rem;">
                <div class="typicalDuration" :style="{border: dataSet[questionIndex].typicalDurationTimerElapsedTime == 0 ? 'red 2px solid' : null}">Typ: {{ secondsToInterval(dataSet[questionIndex].typical_duration) }}</div>
                <div class="time_out" :style="{border: dataSet[questionIndex].timeOutTimerElapsedTime == 0 ? 'red 2px solid' : null}">Time Out: {{ secondsToInterval(dataSet[questionIndex].time_out) }}</div>
                <div class="totalDuration">Duration: 0:00</div>
              </div>
              <div class="d-flex flex-column">
                <div v-for="(item, index) in dataSet[questionIndex].specialist_buttons" :key="index">
                  <button v-if="index % 2 !== 0" class="exampleButton">{{ item.text }}</button>
                </div>
              </div>
            </div>
            <div class="icons-grid w-100" style="grid-column: span 3;">
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/question-circle.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/video.svg" class='preview-icons'/>
                <div>Left</div>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/video-off.svg" class='preview-icons'/>
                <div>Center</div>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/video.svg" class='preview-icons'/>
                <div>Right</div>
              </span>
              <div class="d-inline-block">
                <div
                  :class="[
                    'circle-button',
                    'red-button',
                  ]"
                >
                  0
                </div>
              </div>
              <div v-for="n in highest_score_possible_Int" :key="n" class="d-inline-block">
                <div
                  :class="[
                    'circle-button',
                    n == dataSet[questionIndex].highest_score_possible ? 'greenFull-button' : 'greenLight-button',
                  ]"
                >
                  {{ `+${n}` }}
                </div>
              </div>
              <span class="preview-icon-container disabled-preview-icon" @click="openModal('modal-childPrompts')">
                <img src="../images/icons_svg/general/audio-file.svg" class='preview-icons'/>
                <div>Child Prompts</div>
              </span>
              <span class="preview-icon-container" @click="openModal('modal-procedure')">
                <img src="../images/icons_svg/general/info-circle.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container" @click="openModal('modal-notes')">
                <img src="../images/icons_svg/general/list-edit.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container" @click="openModal('modal-specialist_prompt')">
                <img src="../images/icons_svg/general/lightbulb.svg" class='preview-icons'/>
                <div>Specialist Prompt</div>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/mike.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/camera.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/play.svg" class='preview-icons'/>
                <div>Instruction</div>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/eye-tracking.svg" class='preview-icons'/>
                <div>Eye-tracking</div>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/head-eeg.svg" class='preview-icons'/>
                <div>EEG</div>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/arm-emg.svg" class='preview-icons'/>
                <div>EMG</div>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/heart-pulse.svg" class='preview-icons'/>
                <div>ECG</div>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/augment-reality.svg" class='preview-icons'/>
                <div>Augmented Reality</div>
              </span>
              <span class="preview-icon-container disabled-preview-icon">
                <img src="../images/icons_svg/general/virtual-reality.svg" class='preview-icons'/>
                <div>Virtual Reality</div>
              </span>
            </div>
          </div>
          <button style="margin-right: 1rem; margin-top: 2rem" @click="configDragResizeWindow = !configDragResizeWindow">
            <span v-if="configDragResizeWindow">Close Config Window</span>
            <span v-else>Open Config Window</span>
          </button>
        </dialog>
        <section class="sideBar-box">
          <div style="overflow-y: scroll;">
            <div>
              <h4>
                <span v-if="editToggle">
                  <input type="text" v-model="applicationData.title" @click="e => preventProp(e)" style="text-align: center;" />
                </span>
                <span v-else>
                  {{ applicationData.title }}
                </span>
              </h4>
              <div v-if="editToggle" style="text-align: left">
                <div id="add-question-container">
                  <div style="text-align: center; font-size: 1.2rem; font-weight: 700;">Add a Question</div>
                  <div class="add-categorization-container">
                    <input id="categorization-type-input" type="text" placeholder="Add Type" />
                    <button @click="addCategorization('type', 'categorization-type-input')">+</button>
                  </div>
                  <div v-for="(type, index) in categorizationsData.types" class="categorization-radio-container" :key="`type-${index}`">
                    <input :value="type" type="radio" name="type-add-radio" :key="`type-${index}`" />
                    <span>{{ type }}</span>
                    <button @click="removeCategorization('type', index)">-</button>
                  </div>
                  <div class="categorization-radio-container">
                    <input checked value="none" type="radio" name="type-add-radio" />
                    <span>none</span>
                  </div>
                  <div class="add-categorization-container">
                    <input id="categorization-categ-input" type="text" placeholder="Add Category" />
                    <button @click="addCategorization('categ', 'categorization-categ-input')">+</button>
                  </div>
                  <div v-for="(categ, index) in categorizationsData.categories" class="categorization-radio-container" :key="`categ-${index}`">
                    <input :value="categ" type="radio" name="categ-add-radio" />
                    <span>{{ categ }}</span>
                    <button @click="removeCategorization('categ', index)">-</button>
                  </div>
                  <div class="categorization-radio-container">
                    <input checked value="none" type="radio" name="categ-add-radio" />
                    <span>none</span>
                  </div>
                  <div class="add-categorization-container">
                    <input id="categorization-subCateg-input" type="text" placeholder="Add SubCategory" />
                    <button @click="addCategorization('subCateg', 'categorization-subCateg-input')">+</button>
                  </div>
                  <div v-for="(subCateg, index) in filteredSubCategories" class="categorization-radio-container" :key="`subCateg-${index}`">
                    <input :value="subCateg" type="radio" name="subCateg-add-radio" />
                    <span>{{ subCateg }}</span>
                    <button @click="removeCategorization('subCateg', index)">-</button>
                  </div>
                  <div class="categorization-radio-container">
                    <input checked value="none" type="radio" name="subCateg-add-radio" />
                    <span>none</span>
                  </div>
                  <div style="display: flex; justify-content: center; align-items: center">
                    <button class="modify-buttons" @click="addtoList('type-add-radio', 'categ-add-radio', 'subCateg-add-radio')">
                      +
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <draggable class="sideBar-list" v-model="dataSet" v-bind="{animation: 200}" handle=".draggable-handle">
              <div v-for="(item,index) in dataSet" :key="index" class="draggable-handle drag-sidelist">
                <input v-if="editToggle" placeholder="Add Question Text" type="text" v-model="item.question" :disabled="!editToggle" @click="e => preventProp(e)">
                <div v-else class="drag-side-list-text-container">{{ item.question }}</div>
              </div>
            </draggable>
          </div>
          <div class="navigation-buttons">
            <div>
              <button v-if="!loadingSaveAllChanges" @click="saveAllData">
                Save Application
              </button>
              <button v-else>
                Saving
                <b-spinner small></b-spinner>
              </button>
            </div>
            <div>
              <button @click="openModal('modal-settings')">Settings</button>
            </div>
            <div>
              <button @click="switchStep('exampleReport')">
                Report Example
                <font-awesome-icon :icon="['fas', 'eye']" />
              </button>
            </div>
          </div>
        </section>
        <section class="main-box">
          <div class="d-flex justify-content-between mb-5">
            <button class="editorMode-button" @click="toggleEdit(null)">
              {{ editToggle ? 'You are in Editor Mode' : 'You are in View Mode' }}
              <font-awesome-icon :icon="['fas', 'pencil']" class="pencil-icon" />
            </button>
          </div>
          <button v-for="(item,index) in dataSet" :key="`dataSet-${index}`" @click="() => {openModal('modal-config-question'); formatForNewResolution('preview-screen-specialist'); changeIndex('question', index)}" class="styleList-container">
            <span>{{ item.question }}</span>
            <div class="descripText ml-2 mr-2" style="flex: 1; font-size: .8em;">
              {{ item.question_description }}
            </div>
            <span>
              {{ formatTimeStamp(item.last_updated_at) }}
              <span v-if="editToggle">
                <font-awesome-icon :icon="['far', 'trash-can']" class="mr-2" @click="e => {preventProp(e);removefromList('question',index)}"/>
              </span>
            </span>
          </button>
        </section>
      </div>
      <div v-else-if="currStep == 'exampleReport'">
        <ConfigureReportNewApp :applicationID="applicationID" @backToAppConfig="backToAppConfig"/>
      </div>
    </div>
  </div>
</template>
  
  <script>
    import instance from '../axios.js';
    import draggable from 'vuedraggable';
    import DragResizeElement from './subComponents/DragResizeElement.vue';
    import { v4 as uuidv4 } from 'uuid';
    import Papa from 'papaparse';
    import ConfigureReportNewApp from './subComponents/ConfigureReportNewApp.vue';

    export default {
      components: {
        draggable,
        DragResizeElement,
        ConfigureReportNewApp
      },
      data() {
        return {
          reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
          applicationID: null,
          applicationData: null,
          dataSet: null,
          categorizationsData: null,
          currStep: 'question',
          questionIndex: -1,
          editToggle: false,
          formatType: 'grid',
          showChildView: false,
          selectedObjectMoveResize: {
            element: null,
            detailsObject: null,
          },
          configDragResizeWindow: false,
          loadingPublishApps: false,
          loadingSaveAllChanges: false,
          loadingSaleChanges: false,
          loadingPricingChange: false,

          pricingOption: null,

          inputObjectApp: {
            image: ''
          },

          orangeOne: '#FF9B00',
          orangeTwo: '#eecc9a'
        }
      },
      async created() {
        function placeInArray(arr, value, variableToCheck, findOrder) {
          let low = 0;
          let high = arr.length - 1;
          // Binary search to find the insertion point
          while (low <= high) {
            const mid = Math.floor((low + high) / 2);
            if (arr[mid][variableToCheck] < findOrder) {
              low = mid + 1;
            } else {
              high = mid - 1;
            }
          }

          // If the value is not in the array, insert it at the correct position
          arr.splice(low, 0, value);
          return arr;
        }
        this.applicationID = this.$route.params.applicationID;

        try {
          let applicationResponse = await instance.get(`/api/appAdmin/application/${this.applicationID}`);
          this.applicationData = applicationResponse.data;
          let questionsResponse = await instance.get(`/api/question-admin/application/${this.applicationID}`)
          let categorizations = await instance.get(`/api/appAdmin/categorization/${this.applicationID}`);
          let data = [...questionsResponse.data];
          this.categorizationsData = {
            ...categorizations.data,
            areas: [this.applicationData.area]
          };

          this.pricingOption = this.applicationData.is_free ? 'free' : 'pricing';

          let result = [];
          if (data.length > 0) {
            this.questionIndex = 0;
          }
          for (let i = 0; i < data.length; i++) {
            //parse the score points into usuable strings
            //add temperary variables for functionality
            placeInArray(result, {
              ...data[i],
              child_buttons: JSON.parse(data[i].child_buttons),
              specialist_buttons: JSON.parse(data[i].specialist_buttons),
              child_images: JSON.parse(data[i].child_images),
              time_out: this.intervalToSeconds(data[i].time_out),
              typical_duration: this.intervalToSeconds(data[i].typical_duration),

              //temporary variables not part of the post request
              typicalDurationTimer: null,
              timeOutTimer: null,
              questionDuration: null,
              typicalDurationTimerElapsedTime: this.intervalToSeconds(data[i].typical_duration),
              timeOutTimerElapsedTime: this.intervalToSeconds(data[i].time_out),
              questionDurationTimerElapse: 0,
              numberChildButtons: JSON.parse(data[i].child_buttons).length,
              numberSpecialistButtons: JSON.parse(data[i].specialist_buttons).length,
              numberChildImages: JSON.parse(data[i].child_images).length,
              numberTTSPrompts: data[i].tts_child_prompts.length,
            }, 'question_order', data[i].question_order);    
                    
          }
          this.dataSet = result;
        } catch (err) {
          console.error(err);
        } 
      },
      computed: {
        filteredSubCategories() {
          // Exclude the csubcategore 'none' from the list
          return this.categorizationsData.sub_categories.filter(subCateg => subCateg !== 'none');
        },
        highest_score_possible_Int() {
          return parseInt(this.dataSet[this.questionIndex].highest_score_possible);
        }
      },
      methods: {
        switchStep(step) {
          this.currStep = step;
        },
        pushURL(url) {
          this.$router.push(url);
        },
        backToAppConfig() {
          this.switchStep('question');
        },
        formatTimestamp(timestamp) {
          if (timestamp == null) {
            return 'null';
          }

          const date = new Date(timestamp);
          const options = { year: 'numeric', month: 'long', day: 'numeric' };
          return date.toLocaleDateString('en-US', options);
        },
        secondsToInterval(seconds) {
          const h = Math.floor(seconds / 3600);
          const m = Math.floor((seconds % 3600) / 60);
          const s = seconds % 60;
          return `${h}:${m}:${s}`;
        },
        intervalToSeconds(interval) {
          const [h, m, s] = interval.split(":").map(Number);
          return h * 3600 + m * 60 + s;
        },
        changeIndex(step, index) {
         if (step == 'question') {
            if (index < 0) {
              this.questionIndex = 0;
            }
            else if (index >= this.dataSet.length) {
              this.questionIndex = this.dataSet.length-1;
            }
            else {
              this.questionIndex = index;
            }
          }
        },
        changePreviewQuestion(newIndex, previousIndex) {
          this.changeIndex('question', newIndex);
          if (0 <= newIndex && newIndex < this.dataSet.length) {
            this.previewTimingPack(this.dataSet[previousIndex], false);
            this.previewTimingPack(this.dataSet[newIndex], true);
          }
        },
        toggleEdit(determination) {
          if (determination == null) {
            this.editToggle = !this.editToggle;
          }
          else if (determination) {
            this.editToggle = true;
          }
          else if (!determination) {
            this.editToggle = false;
          }
        },
        childViewToggle() {
          this.showChildView = !this.showChildView;
        },
        addtoList(typeRadioGroup, categRadioGroup, subCategRadioGroup) {
          let typeInputRef = document.querySelector(`input[name="${typeRadioGroup}"]:checked`);
          let categInputRef = document.querySelector(`input[name="${categRadioGroup}"]:checked`);
          let subCategInputRef = document.querySelector(`input[name="${subCategRadioGroup}"]:checked`);

          if (typeInputRef.value == 'none' || typeInputRef.value == null || categInputRef.value == 'none' || categInputRef.value == null) {
            alert(`Please select/add a type and category that is not "none"`);
            return;
          }

          if (subCategInputRef == null) {
            alert(`Please select "none" or another SubCategory`);
            return;
          }

          let id = uuidv4();
          let time_out = 15;
          let typicalDuration = 5;
          this.dataSet.splice(this.dataSet.length, 0, {
            application_id: this.applicationID,
            question_id: id,
            custom_id: '',
            question: '',
            question_description: '',
            question_order: this.dataSet.length,
            area: this.applicationData.area,
            area_description: '',
            type: typeInputRef.value,
            type_description: '',
            category: categInputRef.value,
            category_description: '',
            sub_category: subCategInputRef.value,
            sub_category_description: '',
            background_color: '#FFFFFF',
            procedure: '',
            age_group: '[0,18)',
            specialist_prompt: '',
            child_buttons: [],
            specialist_buttons: [],
            child_images: [],
            child_view_original_screen_resolution: '804x640',
            highest_score_possible: 1,
            tts_child_prompts: [],
            time_out: time_out,
            typical_duration: typicalDuration,
            note: '',

            typicalDurationTimer: null,
            timeOutTimer: null,
            questionDuration: null,
            typicalDurationTimerElapsedTime: time_out,
            timeOutTimerElapsedTime: typicalDuration,
            questionDurationTimerElapse: 0,

            numberChildButtons: 0,
            numberSpecialistButtons: 0,
            numberTTSPrompts: 0,
            numberChildImages: 0,
            numberSpecialistImages: 0,
          });

          if (this.dataSet.length > 0 && this.questionIndex <= -1) {
            this.questionIndex = 0;
          }
        },
        removefromList(location, index) {
          if (location == 'question') {
            index == null ? this.dataSet.splice(this.questionIndex, 1) : this.dataSet.splice(index, 1);
            if (this.dataSet.length == this.questionIndex) {
              this.questionIndex = this.questionIndex-1;
            }
          } 
        },
        addCategorization(categorization, inputID) {
          function checkDuplicate(array, value) {
            for (let i = 0; i < array.length; i++) {
              if (array[i] == value) {
                alert("Input Value cannot be Repeat Value");
                return true;
              }
            }
          }


          let inputRef = document.getElementById(inputID);

          if (inputRef.value == '') {
            alert('Input Value cannot be Empty');
            return;
          }

          if (inputRef.value == 'none') {
            alert(`Input Value cannot be "none"`);
          }

          if (categorization == 'type') {
            if (checkDuplicate(this.categorizationsData.types, inputRef.value)) {
              return;
            }
            this.categorizationsData.types = [
              ...this.categorizationsData.types,
              inputRef.value
            ];
          } else if (categorization == 'categ') {
            if (checkDuplicate(this.categorizationsData.categories, inputRef.value)) {
              return;
            }
            this.categorizationsData.categories = [
              ...this.categorizationsData.categories,
              inputRef.value
            ];
          } else if (categorization == 'subCateg') {
            if (checkDuplicate(this.categorizationsData.sub_categories, inputRef.value)) {
              return;
            }
            this.categorizationsData.sub_categories = [
              ...this.categorizationsData.sub_categories,
              inputRef.value
            ];
          }
          inputRef.value = '';
        },
        removeCategorization(categorization, index) {
          function checkCategoryAssociatedWithQuestion(array, property, value) {
            for (let i = 0; i < array.length; i++) {
              if (array[i][property] == value) {
                alert(`To remove this category please remove the question(s) associated with ${value}`);
                return true;
              }
            }
          }

          if (categorization == 'type') {
            if (checkCategoryAssociatedWithQuestion(this.dataSet, 'type', this.categorizationsData.types[index])) {
              return;
            }
            this.categorizationsData.types.splice(index, 1);
          } else if (categorization == 'categ') {
            if (checkCategoryAssociatedWithQuestion(this.dataSet, 'category', this.categorizationsData.categories[index])) {
              return;
            }
            this.categorizationsData.categories.splice(index, 1);
          } else if (categorization == 'subCateg') {
            if (checkCategoryAssociatedWithQuestion(this.dataSet, 'sub_category', this.categorizationsData.sub_categories[index])) {
              return;
            }
            this.categorizationsData.sub_categories.splice(index, 1);
          }
        },
        preventProp(event) {
          event.stopPropagation();
        },
        handleFileChangeObject(event, object, variable) {
          //object is reference and variable is property to change
          let file = event.target.files[0];
          object[variable] = file;
        },
        handleInputChangeObject(event, object, property) {
          //object is reference and variable is property to change
          object[property] = event.target.value;
        },
        numberFormatImageChange(question, config, number) {
          //tells when to add or remove array element for button number change
          //config is a string for reference
          let difference = number - question[config].length;
          if (difference < 0) {
            question[config].splice(number, -difference);
          }
          else {
            const newArray = new Array(difference).fill({
              file: null,
              fileRef: null,
              x: 0,
              y: 0,
              width: 400,
              height: 200,
              background_color: this.orangeTwo,
              zIndex: 5
            });
            question[config] = question[config].concat(newArray);
          }
        },
        numberFormatButtonChange(question, config, number) {
          //tells when to add or remove array element for button number change
          //config is a string for reference
          let difference = number - question[config].length;
          if (difference < 0) {
            question[config].splice(number, -difference);
          }
          else {
            const newArray = new Array(difference).fill({
              text: '',
              file: null,
              fileRef: null,
              x: 0,
              y: 0,
              width: 400,
              height: 200,
              background_color: this.orangeOne,
              fontSize: 16,
              zIndex: 5
            });
            question[config] = question[config].concat(newArray);
          }
        },
        addTemplateElements(questionObject, templateName) {
          let [originalWidth, originalHeight] = questionObject.child_view_original_screen_resolution.split('x').map(Number);
          let newArrayButton = [];
          let newArrayImage = [];
          let margin = 5;

          let quarterHeight = originalHeight / 4;
          let quarterWidth = originalWidth / 4;

          if (templateName == '1') {
            newArrayImage.push({
              file: null,
              fileRef: null,
              x: margin,
              y: margin,
              width: originalWidth - margin*2,
              height: originalHeight - margin*2,
              background_color: this.orangeTwo,
              zIndex: 5
            });
            this.dataSet[this.questionIndex].numberChildImages += 1;
            this.dataSet[this.questionIndex].numberChildButtons += 0;
          } else if (templateName == '2') {
            newArrayImage.push({
              file: null,
              fileRef: null,
              x: margin,
              y: margin,
              width: originalWidth - margin*2,
              height: quarterHeight*3 - margin*2,
              background_color: this.orangeTwo,
              zIndex: 5
            });
            this.horizontalRow(newArrayButton, 'button', 2, margin, quarterHeight*3 + margin, quarterHeight - margin*4, originalWidth, margin);
            this.dataSet[this.questionIndex].numberChildImages += 1;
            this.dataSet[this.questionIndex].numberChildButtons += 2;
          } else if (templateName == '3') {
            newArrayImage.push({
              file: null,
              fileRef: null,
              x: margin,
              y: margin,
              width: originalWidth/2 - margin*2,
              height: originalHeight - margin*2,
              background_color: this.orangeTwo,
              zIndex: 5
            });
            this.verticalColumn(newArrayButton, 'button', 6, originalWidth/2 + margin, margin, originalWidth/2 - margin*2, originalHeight, margin);
            this.dataSet[this.questionIndex].numberChildImages += 1;
            this.dataSet[this.questionIndex].numberChildButtons += 6;
          } else if (templateName == '4') {
            newArrayImage.push({
              file: null,
              fileRef: null,
              x: margin,
              y: margin,
              width: originalWidth - margin*2,
              height: quarterHeight*3 - margin*2,
              background_color: this.orangeTwo,
              zIndex: 5
            });
            this.horizontalRow(newArrayButton, 'button', 2, margin, quarterHeight*3 + margin, quarterHeight/2 - margin*4, originalWidth, margin);
            this.horizontalRow(newArrayButton, 'button', 2, margin, quarterHeight*3 + margin*2 + (quarterHeight/2 - margin*4), quarterHeight/2 - margin*4, originalWidth, margin)
            this.dataSet[this.questionIndex].numberChildImages += 1;
            this.dataSet[this.questionIndex].numberChildButtons += 4;
          } else if (templateName == '5') {
            newArrayImage.push({
              file: null,
              fileRef: null,
              x: quarterWidth + margin,
              y: margin,
              width: quarterWidth*2 - margin*2,
              height: originalHeight - margin*2,
              background_color: this.orangeTwo,
              zIndex: 5
            }); 
            this.verticalColumn(newArrayButton, 'button', 2, margin, margin, quarterWidth - margin*2, originalHeight, margin);
            this.verticalColumn(newArrayButton, 'button', 2, originalWidth - quarterWidth + margin, margin, quarterWidth - margin*2, originalHeight, margin);
            this.dataSet[this.questionIndex].numberChildImages += 1;
            this.dataSet[this.questionIndex].numberChildButtons += 4;
          } 
          questionObject.child_buttons = questionObject.child_buttons.concat(newArrayButton);
          questionObject.child_images = questionObject.child_images.concat(newArrayImage);
        },
        verticalColumn(array, type, count, startX, startY, width, totalHeightAvailable, margin) {
          let availableHeight = (totalHeightAvailable - margin*2) - (margin * (count - 1));
          let rectHeight = availableHeight / count;

          if (type == 'image') {
            for (let i = 0; i < count; i++) {
              array.push({
                file: null,
                fileRef: null,
                x: startX,
                y: startY + i * (rectHeight + margin),
                width: width,
                height: rectHeight,
                background_color: this.orangeTwo,
                zIndex: 5
              })
            }
          } else if (type == 'button') {
            for (let i = 0; i < count; i++) {
              array.push({
                text: '',
                file: null,
                fileRef: null,
                x: startX,
                y: startY + i * (rectHeight + margin),
                width: width,
                height: rectHeight,
                background_color: this.orangeOne,
                fontSize: 16,
                zIndex: 5
              })
            }
          }
        },
        horizontalRow(array, type, count, startX, startY, height, totalWidthAvailable, margin) {
          let availableWidth = (totalWidthAvailable - margin*2) - (margin * (count - 1));
          let rectWidth = availableWidth / count;
          
          if (type == 'image') {
            for (let i = 0; i < count; i++) {
              array.push({
                file: null,
                fileRef: null,
                x: startX + i * (rectWidth + margin),
                y: startY,
                width: rectWidth,
                height: height,
                background_color: this.orangeTwo,
                zIndex: 5
              })
            }
          } else if (type == 'button') {
            for (let i = 0; i < count; i++) {
              array.push({
                text: '',
                file: null,
                fileRef: null,
                x: startX + i * (rectWidth + margin),
                y: startY,
                width: rectWidth,
                height: height,
                background_color: this.orangeOne,
                fontSize: 16,
                zIndex: 5
              })
            }
          }
        },
        numberTTSPromptChange(question,config,number) {
          //tells when to add or remove array element for button number change
          //config is a string for reference
          let difference = number - question[config].length;
          if (difference < 0) {
            question[config].splice(number, -difference);
          }
          else {
            const newArray = new Array(difference).fill('');
            question[config] = question[config].concat(newArray);
          }
        },
        updateTTSPrompt(array, index, event) {
          array[index] = event.target.value;
        },
        getAudioFileSrc(fileObject) {
          if (fileObject != null) {
            return URL.createObjectURL(fileObject);
          }
          return null;
        },
        getImageFileSrc(imageDetailObject) {
          if (imageDetailObject.file != null) {
            return URL.createObjectURL(imageDetailObject.file);
          } else {
            return null;
          }
        },
        getURLImage(file) {
          if (file != null && file != '') {
            return URL.createObjectURL(file);
          } else {
            return null;
          }
        },
        startStopWatch(questionFunctions, stopWatchName, stopWatchElapseTimeName) {
          //questionFunctions is Object
          questionFunctions[stopWatchName] = setInterval(() => {
            questionFunctions[stopWatchElapseTimeName]++;
          }, 1000);
        },
        stopStopWatch(questionFunctions, stopWatchName) {
          //questionFunctions is Object
          clearInterval(questionFunctions[stopWatchName]);
          questionFunctions[stopWatchName] = null;
        },
        resetStopWatch(questionObject, stopWatchName, stopWatchElapseTimeName) {
          let questionFunctions = questionObject;
          questionFunctions[stopWatchElapseTimeName] = 0;
          this.stopStopWatch(questionFunctions, stopWatchName);
          this.startStopWatch(questionFunctions, stopWatchName, stopWatchElapseTimeName);
        },
        startTimer(questionFunctions, timerName, timerElapseTimeName) {
          //questionFunctions is Object
          questionFunctions[timerName] = setInterval(() => {
            let temp = questionFunctions[timerElapseTimeName];
            if (temp - 1 < 0) {
              this.stopTimer(questionFunctions, timerName);
            }
            else {
              questionFunctions[timerElapseTimeName]--;
            }
          }, 1000);
        },
        stopTimer(questionFunctions, timerName) {
          //questionFunctions is Object
          clearInterval(questionFunctions[timerName]);
          questionFunctions[timerName] = null;
        },
        resetTimer(questionObject, timerName, timerElapseTimeName, originalTimeName) {
          let questionFunctions = questionObject;
          questionFunctions[timerElapseTimeName] = questionObject[originalTimeName];
          this.stopTimer(questionFunctions, timerName);
          this.startTimer(questionFunctions, timerName, timerElapseTimeName);
        },
        previewTimingPack(questionObject, setting) {
          let questionFunctions = questionObject;
          //turn on timings
          if (setting) {
            this.startTimer(questionFunctions, 'typicalDurationTimer', 'typicalDurationTimerElapsedTime');
            this.startTimer(questionFunctions, 'timeOutTimer', 'timeOutTimerElapsedTime');
            this.startStopWatch(questionFunctions, 'questionDuration', 'questionDurationTimerElapse');
          }
          else {
            this.stopTimer(questionFunctions, 'typicalDurationTimer');
            this.stopTimer(questionFunctions, 'timeOutTimer');
            this.stopStopWatch(questionFunctions, 'questionDuration');
          }
        },
        previewTimingResetPack(questionObject) {
          this.resetTimer(questionObject, 'typicalDurationTimer', 'typicalDurationTimerElapsedTime', 'typicalDuration');
          this.resetTimer(questionObject, 'timeOutTimer', 'timeOutTimerElapsedTime', 'time_out');
          this.resetStopWatch(questionObject, 'questionDuration', 'questionDurationTimerElapse');
        },
        formatTimeStamp(timeStamp) {
          const dateStr = timeStamp;
          const date = new Date(dateStr);
          const formattedDate = `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}`;

          return formattedDate;
        },
        openModal(id) {
          document.getElementById(id).showModal();
        },
        closeModal(id) {
          document.getElementById(id).close();
        },
        convertToSpeech(textInput) {
          if ('speechSynthesis' in window) {
            window.speechSynthesis.cancel();
            const utterance = new SpeechSynthesisUtterance(textInput);
            window.speechSynthesis.speak(utterance);
          }
          else {
            alert('Web Speech API is not supported in this browser.');
          }
        },
        stopAllConvertToSpeech() {
          if ('speechSynthesis' in window) {
            window.speechSynthesis.cancel();
          }
        },
        playAudio(id) {
          this.stopAllAudio();
          let audio = document.getElementById(id);
          if (audio.paused) {
            audio.play();
          }
          else {
            audio.currentTime = 0;
          }
        },
        stopAllAudio() {
          let audioElements = document.getElementsByClassName('audio-tag');
          for (let i = 0; i < audioElements.length; i++) {
            audioElements[i].pause();
            audioElements[i].currentTime = 0;
          }
        },
        formatForNewResolution(elementID) {
          this.$nextTick(() => {
            let currentQuestionInstance = this.dataSet[this.questionIndex];
            let [originalWidth, originalHeight] = currentQuestionInstance.child_view_original_screen_resolution.split('x').map(Number);
            let newWidth = document.getElementById(elementID).offsetWidth;
            let newHeight = document.getElementById(elementID).offsetHeight;
            if (newWidth == originalWidth && newHeight == originalHeight) {
              return;
            }

            //[x,y] transform coordinates from original to new resolution
            let xTransform = newWidth / originalWidth;
            let yTransform = newHeight / originalHeight;

            for (let i = 0; i < currentQuestionInstance.child_buttons.length; i++) {
              currentQuestionInstance.child_buttons[i].x *= xTransform;
              currentQuestionInstance.child_buttons[i].y *= yTransform;
              currentQuestionInstance.child_buttons[i].height *= yTransform;
              currentQuestionInstance.child_buttons[i].width *= xTransform;
            }

            for (let i = 0; i < currentQuestionInstance.child_images.length; i++) {
              currentQuestionInstance.child_images[i].x *= xTransform;
              currentQuestionInstance.child_images[i].y *= yTransform;
              currentQuestionInstance.child_images[i].height *= yTransform;
              currentQuestionInstance.child_images[i].width *= xTransform;
            }

            currentQuestionInstance.child_view_original_screen_resolution = `${newWidth}x${newHeight}`;
          });
        },
        async saveAllData() {
          try {
            this.loadingSaveAllChanges = true;
            const formDataQuestion = new FormData();
            let allQuestions = [];

            this.dataSet.forEach((question, questionIndex) => {
              let editedchild_buttons = [];
              Array.from(question.child_buttons).forEach((button) => {
                let uniqueName = '';
                if (!button.fileRef) {
                  if (button.file != null && button.file != "") {
                    uniqueName = `${Date.now()}_${Math.random().toString(36).slice(2, 7)}_${button.file.name}`;
                    formDataQuestion.append(uniqueName, button.file, uniqueName);
                  } else {
                    uniqueName = "";
                  }
                }
                editedchild_buttons.push({
                  ...button,
                  file: null,
                  fileRef: uniqueName,
                  x: parseInt(button.x),
                  y: parseInt(button.y),
                  width: parseInt(button.width),
                  height: parseInt(button.height),
                  fontSize: parseInt(button.fontSize),
                  zIndex: parseInt(button.zIndex)
                })
              });
              let editedchild_images = [];
              Array.from(question.child_images).forEach((image) => {
                let uniqueName = '';
                if (!image.fileRef) {
                  if (image.file != null && image.file != "") {
                    uniqueName = `${Date.now()}_${Math.random().toString(36).slice(2, 7)}_${image.file.name}`;
                    formDataQuestion.append(uniqueName, image.file, uniqueName);
                  } else {
                    uniqueName = "";
                  }
                }
                editedchild_images.push({
                  ...image,
                  file: null,
                  fileRef: uniqueName,
                  x: parseInt(image.x),
                  y: parseInt(image.y),
                  width: parseInt(image.width),
                  height: parseInt(image.height),
                  zIndex: parseInt(image.zIndex)
                })
              });

              allQuestions.push({
                "application_id": question.application_id,
                "question_id": question.question_id,
                "custom_id": question.custom_id,
                "question": question.question,
                "question_description": question.question_description,
                "question_order": questionIndex,
                "area": question.area,
                "area_description": question.area_description,
                "type": question.type,
                "type_description": question.type_description,
                "category": question.category,
                "category_description": question.category_description,
                "sub_category": question.sub_category,
                "sub_category_description": question.sub_category_description,
                "background_color": question.background_color,
                "procedure": question.procedure,
                "age_group": question.age_group,
                "specialist_prompt": question.specialist_prompt,
                "child_buttons": editedchild_buttons,
                "specialist_buttons": JSON.stringify(question.specialist_buttons),
                "child_images": editedchild_images,
                "child_view_original_screen_resolution": question.child_view_original_screen_resolution,
                "highest_score_possible": parseInt(question.highest_score_possible),
                "TTS_child_prompts": question.tts_child_prompts,
                "time_out": this.secondsToInterval(question.time_out),
                "typical_duration": this.secondsToInterval(question.typical_duration),
                "note": question.note
              })
            })
            formDataQuestion.append("applicationID", this.applicationID)
            formDataQuestion.append("dataStructure", JSON.stringify(allQuestions));
            await instance.put('/api/question-admin/application/questions', formDataQuestion, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })

            const formDataApp = new FormData();
            formDataApp.append("application_custom_id", this.applicationData.application_custom_id);
            formDataApp.append("classification", this.applicationData.classification);
            formDataApp.append("title", this.applicationData.title);
            formDataApp.append("subtitle", this.applicationData.subtitle);
            formDataApp.append("info", this.applicationData.info);
            formDataApp.append("area", this.applicationData.area);
            formDataApp.append("image", this.inputObjectApp.image == '' ? null : this.inputObjectApp.image);
            formDataApp.append("on_sale", this.applicationData.on_sale);
            formDataApp.append("is_free", this.pricingOption == 'free' ? true : false);
            formDataApp.append("currency_code", this.applicationData.currency_code);
            formDataApp.append("single_unit_pricing", this.applicationData.single_unit_pricing);
            formDataApp.append("large_quantity_discount", this.applicationData.large_quantity_discount);
            formDataApp.append("monthly_subscription_pricing", this.applicationData.monthly_subscription_pricing);
            formDataApp.append("published", this.applicationData.published);

            await instance.patch(`/api/appAdmin/${this.applicationID}`, formDataApp, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })

            this.loadingSaveAllChanges = false;
            alert('Data Saved');
          } catch (e) {
            alert(`Error Data not Saved: ${e.message}`);
            this.loadingSaveAllChanges = false;
            console.error(e);
          }
        },
        exportAsCSV() {
          let allQuestions = [];
          this.dataSet.forEach((question, questionIndex) => {
            allQuestions.push({
              ...question,
              "question_order": questionIndex,
              "child_buttons": JSON.stringify(question.child_buttons),
              "specialist_buttons": JSON.stringify(question.specialist_buttons),
              "child_images": JSON.stringify(question.child_images),
              "TTS_child_prompts": JSON.stringify(question.tts_child_prompts),
              "time_out": question.time_out,
              "typical_duration": question.typicalDuration,
            })
          })
 
          const csv = Papa.unparse(allQuestions);

          const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
          const link = document.createElement('a');
          link.setAttribute('href', URL.createObjectURL(blob));
          link.setAttribute('download', 'data.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        async changeSale(boolean) {
          try {
            this.loadingSaleChanges = true;
            const formData = new FormData();
            formData.append("on_sale", boolean);
            await instance.patch(`/api/appAdmin/${this.applicationID}`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            this.applicationData.on_sale = boolean;
            this.loadingSaleChanges = false;
            alert(`Application Has Been set ${boolean ? 'On Sale' : 'Not On Sale'}`);
          } catch (e) {
            console.error(e);
            this.loadingSaleChanges = false;
            alert('Error Application Was Not Published');
          }
        },
        async publishApp(boolean) {
          try {
            this.loadingPublishApps = true;
            const formData = new FormData();
            formData.append("published", boolean);
            await instance.patch(`/api/appAdmin/${this.applicationID}`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            this.applicationData.published = boolean;
            this.loadingPublishApps = false;
            alert(`Application Has Been ${boolean ? 'Published' : 'UnPublished'}`);
          } catch (e) {
            console.error(e);
            this.loadingPublishApps = false;
            alert('Error Application Was Not Published');
          }
        },
        selectObjectMoveResize(event, detailsObject) {
          let elements = document.querySelectorAll('.selected-drag-resize');
          elements.forEach(element => {
            let handles = element.querySelector('.resizeHandles');
            handles.classList.remove('activeHandles'); 
            element.classList.remove('selected-drag-resize');
          });

          this.selectedObjectMoveResize.detailsObject = detailsObject;
          this.selectedObjectMoveResize.element = event.currentTarget;
        },
        deselectObjectMoveResize() {
          let obj = this.selectedObjectMoveResize;
          let elements = document.querySelectorAll('.selected-drag-resize');
          elements.forEach(element => {
            let handles = element.querySelector('.resizeHandles');
            handles.classList.remove('activeHandles'); 
            element.classList.remove('selected-drag-resize');
          });
          Object.keys(obj).forEach(key => {
            obj[key] = null;
          });
          this.selectedObjectMoveResize.detailsObject = null;
          this.selectedObjectMoveResize.element = null;
        },
        findandRemoveImageButton(detailsObject) {
          let shorthandImage = this.dataSet[this.questionIndex].child_images;
          let shorthandButton = this.dataSet[this.questionIndex].child_buttons;
          for (let i = 0; i < shorthandImage.length; i++) {
            if (detailsObject == shorthandImage[i]) {
              shorthandImage.splice(i, 1);
              Object.keys(this.selectedObjectMoveResize).forEach(key => {
                this.selectedObjectMoveResize[key] = null;
              });
              this.dataSet[this.questionIndex].numberChildImages--;
              return;
            }
          }
          for (let i = 0; i < shorthandButton.length; i++) {
            if (detailsObject == shorthandButton[i]) {
              shorthandButton.splice(i, 1);
              Object.keys(this.selectedObjectMoveResize).forEach(key => {
                this.selectedObjectMoveResize[key] = null;
              });
              this.dataSet[this.questionIndex].numberChildButtons--;
              return;
            }
          }
        },
        scrollToElement(id) {
          let ref = document.getElementById(id);
          ref.scrollIntoView({
            behavior: 'smooth', 
            block: 'start'
          });
        },
        base64ToFile(base64String, filename) {
          const mimeType = base64String.split(';')[0].split(':')[1];
          const base64Data = base64String.split(',')[1];
          const binaryString = window.atob(base64Data);
          const byteArray = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            byteArray[i] = binaryString.charCodeAt(i);
          }
          const blob = new Blob([byteArray], { type: mimeType });
          const file = new File([blob], filename, { type: mimeType });
          return file;
        }
      },
    }
  </script>
  
  <style lang="scss" scoped>
    @use 'sharedSCSS/globalSharedVariables';

    $sidebar-width: 400px;
    $primary-color: globalSharedVariables.$orange-1;
    $greenFull: #ace2c6;
    $greenLight: #D9F2E6;
    $redZero: #FFBCBC;

    img {
      -webkit-user-drag: none
    }

    #container {
      position: relative;

      > div {
        width: 100%;
      }
    }

    .flexCenterCenter {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .flexBtwCenter {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .sideBar-box {
      width: $sidebar-width;
      position: fixed;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: calc(100vh - #{globalSharedVariables.$navbar-height});
    
      h4 {
        text-align: center;

        input[type="text"] {
          font-size: 1.5rem;
          width: 75%;
        }
      }

      .navigation-buttons {
        button {
          width: 100%;
          margin: 5px 0;
        }
      }

      #add-question-container {
        font-size: .7rem;
        border: solid black 1px;
        padding: .5rem;
        border-radius: 1rem;

        .add-categorization-container {
          display: flex;
          align-items: center;

          input[type="text"] {
            font-size: .9rem;
          }

          > button {
            padding: 0;
            width: 17px;
            height: 17px;
            margin-left: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .categorization-radio-container {
          margin-left: 1rem;
          margin-top: 5px;
          display: flex;
          align-items: center;

          input[type="radio"] {
            cursor: pointer;
            accent-color: $primary-color;
            width: .7rem;
            margin-right: 5px;
          }

          > button {
            padding: 0;
            width: 17px;
            height: 17px;
            margin-left: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .modify-buttons {
          border-radius: 5px;
          margin: 0 .25rem;
          width: 50px;
          text-align: center;
          padding: 0;
          font-size: 1rem;
        }
      }

      .sideBar-list {
        flex-grow: 1;
        margin: 1rem 0;

        input {
          padding: 5px 10px;
        }

        .drag-sidelist {
          cursor: grab;
          margin: 5px 0;
          border: solid black 1px;
          padding: .5rem;
          border-radius: 5px;

          .drag-side-list-text-container {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    .main-box {
      margin-left: $sidebar-width;

      .editorMode-button {
        color: grey;
        border: solid grey 1px;
        font-size: .6em;
        width: 150px;
        border-radius: 50rem;
        padding-left: .5rem;
        padding-right: .5rem;
        margin-top: .25rem;
        margin-left: .5rem;
      }

      .pencil-icon {
        color: grey;
      }

      .styleList-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        user-select: none;
        cursor: pointer;
        width: 100%;
        margin: 5px 0;
      }

      .descripText {
        font-weight: 400;
        color: #606060;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    #config-control-box-specialist {
      display: grid;
      grid-template-columns: 1fr 4fr 1fr;
      row-gap: 2rem;
      column-gap: 1rem;

      .border-color-primary {
        outline: solid 2px $primary-color;
      }

      .prev-ques-nav-buttons {
        cursor: pointer;
        padding: 0;
        margin: 0 2px;

        img {
          width: 30px;
          border-radius: 50rem;

          &:hover {
            background-color: $primary-color;
          }
        }
      }
      
      .typicalDuration {
        border: solid #FAFD5F 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
      }

      .time_out {
        border: solid #2B870B 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
      }

      .totalDuration {
        border: solid black 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
      }

      .exampleButton {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 100%;

        &:hover {
          opacity: .8;
        }
      }

      .preview-icons {
        width: 50px;
        height: 24px;
      }

      .preview-icon-container {
        font-size: xx-small;
        text-align: center;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 50px;
        width: 50px;
        cursor: pointer;

        div {
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translate(-50%, 50%);
        }

        &.disabled-preview-icon {
          opacity: .2;
          cursor: default;
        }
      }

      .circle-button {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      .greenFull-button {
        box-shadow: inset 0 0 2px 2px $greenFull;
        color: $greenFull;
        border: 1px solid green;
        -webkit-text-stroke: 1px black;

        &:hover {
          background-color: $greenFull;
        }

        &.selected-score-button {
          background-color: $greenFull;
        }
      }

      .greenLight-button {
        box-shadow: inset 0 0 2px 2px $greenLight;
        color: $greenLight;
        border: 1px solid rgb(0, 156, 0);
        -webkit-text-stroke: 1px black;

        &:hover {
          background-color: $greenLight;
        }

        &.selected-score-button {
          background-color: $greenLight;
        }
      }

      .red-button {
        box-shadow: inset 0 0 2px 2px $redZero;
        color: $redZero;
        border: 1px solid red;
        -webkit-text-stroke: 1px black;

        &:hover {
          background-color: $redZero;
        }

        &.selected-score-button {
          background-color: $redZero;
        }
      }

      .icons-grid {
        display: grid;
        grid-template-columns: repeat(11, auto);
      }
    }

    #question-configuration-window-container {
      height: 75%;
      width: 75%;

      .template-container {
        position: relative;
        display: inline-block;

        svg {
          width: 100px;
          height: 100px;
          border: solid black 1px;
          border-radius: 5px;
          margin: 2px;
        }
        button {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        
        &:hover button {
          display: block;
        }

        &:hover svg {
          fill-opacity: .1;
        }
      }
      svg {
        width: 100px;
        height: 100px;
        border: solid black 1px;
        border-radius: 5px;
        margin: 2px;
      }
    }

    .config-drag-resize-window {
      font-weight: 400;
      border: solid black 2px;
      border-radius: 5px;
      padding: .5rem;
      z-index: 150;
      background-color: white;
    }

    .drag-resize-element-container {
      overflow: auto;
      height: 100%;
      background-color: white;

      h4 {
        text-align: center;
      }

      button {
        font-size: .8rem;
      }

      .masonry {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        grid-auto-rows: auto;
        gap: 20px;

        > div {
          &.grid-span-column-2 {
            grid-column: span 2;
          }

          hr {
            margin: 5px 0;
            border-width: 0;
            background-color: black;
            height: 1px;
            opacity: 1;
          }

          h5 {
            text-align: center;
            text-decoration: underline;
          }

          h6 {
            text-align: center;
          }

          border: solid black 1px;
          border-radius: 10px;
          padding: 1rem;
        }
      }

      table {
        td {
          font-size: .8rem;
          padding: 5px;

          input {
            font-size: .8rem;
          }
        }
      }
    }

    #modal-config-question {
      width: 75%;

      input[type="text"] {
        padding: 5px 5px;
      }

      input, textarea, select {
        font-size: .8rem;
      }

      table {
        td {
          font-size: .8rem;
          padding: 5px;
        }
      }
    }

    #modal-settings {
      h3, h5 {
        text-align: center;
      }

      hr {
        margin: 5px 0;
        border-width: 0;
        background-color: black;
        height: 1px;
        opacity: 1;
      }

      .border-color {
        border: solid 1px $primary-color;
        padding: 5px;
        margin: 1rem 0;
        border-radius: 10px;
      }

      #pricing-sublist {
        margin-left: 1.2rem;
        font-size: .8rem;

        select, input {
          font-size: .8rem;
        }

        > div {
          margin: 2px 0;
        }
      }

      .modal-settings-content-grid {
        display: grid;
        grid-template-columns: auto auto;
        column-gap: 25px;
        row-gap: 5px;

        & > div:nth-child(odd) {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }

        & > div:nth-child(even) {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          > div {
            width: 100%;
          }
        }

      }

      button {
        width: 100%;
        margin: 5px 0;
      }
    }

    .resizable-image-container, .final-image-container {
      $local-border-radius: 1rem;

      background-color: $primary-color;
      border-radius: $local-border-radius;
      border: solid black 1px;
      position: absolute;
      user-select: none;
      cursor: pointer;

      img {
        border-radius: $local-border-radius;
      }
    }

    .resizable-button-container, .final-button-container {
      $local-border-radius: 1rem;

      background-color: $primary-color;
      position: absolute;
      border-radius: $local-border-radius;
      box-shadow: 0 0 5px 5px lightgrey;
      border: solid black 1px;
      user-select: none;
      cursor: pointer;
      
      .placeholder-rect {
        position: absolute;
        top: 0;
        left: 0;
        word-wrap: break-word;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      img {
        border-radius: $local-border-radius;
      }
    }

    section {
      padding: 20px;
    }

    h4 {
      font-weight: 700;
      user-select: none;
    }

    p {
      font-weight: 400;
      font-size: 1rem;
    }

    table {
      td {
        padding: .5rem;
      }

      input[type="text"] {
        display: inline-block;
        font-weight: 400;
      }

      input[type="text"]:disabled, textarea {
        color: black;
        background-color: white;
        border-radius: 10px;
        font-weight: 400;
      }

      input[type="number"] {
        font-weight: 400;
        background-color: white;
        font-size: 1rem;
      }

      input[type="file"] {
        display: none;
      }

      tr td:nth-child(1) {
        text-align: right;
        line-height: .9;
      }

      tr td:nth-child(2) > span {
        background-color: white;
        border-radius: 50rem;
        padding: 0 .5rem;
        font-size: 1rem;
        font-weight: 400;
      }

      select {
        font-size: 1rem;
        font-weight: 400;
        background-color: white;
        border-radius: 50rem;
        padding: 0 1rem;
        cursor: pointer;
      }

      input {
        border-radius: 50rem;
        padding-left: .5rem;
        padding-right: .5rem;
      }
    }

    textarea {
      height: 100px;
      width: 100%;
    }
  </style>